export let routes = [
  {
    path: '/x3-side-depart',
    name: 'x3-side-depart',
    component: () => import('@x3/js/side/depart/depart.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsDepart(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-depart',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};